class Icons {
    constructor(icons) {
        this.icons = icons;
    }
}

export default Icons;
